module.exports = __webpack_public_path__ + "pic_bizny_web_03@1x.png?8e3327017646a5314f297726c31df34b";